<template>
  <v-row justify="center">
    <v-dialog v-model="active" :persistent="fix" max-width="500">
      <v-card class="pa-3">
        <div class="close-dialog-btn mt-2" style="top: 22px">
          <v-icon v-if="!fix" size="28px" color="#D8DDE4" @click="close">mdi-close</v-icon>
        </div>
        <v-card-title class="text-h5 my-1" style="font-weight:800">
          {{title}}
        </v-card-title>
        <v-card-text class="text-left mt-1" style="font-weight:600; height:80px; font-size:15px">
          {{content}}
        </v-card-text>
        <v-card-actions class="mb-2 px-3" style="justify-content:center">
          <v-btn class="colorBtn primary-color-background" outlined color="#FFF" @click="save">
            {{ $t('__confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import i18n from '../plugins/i18n'
  export default {
    name:'ShowMsg',
    props:['onSave'],
    data () {
      return {
        active: false,
        title: '',
        content: '',
        onSaveEn: false,
        fix: false,
      }
    },
    methods:{
      open(type = null, title = null, content = null, onSaveEn = false, fix = false){
        this.active = true
        this.onSaveEn = onSaveEn
        this.fix = fix
        switch(type){
          case 0:
          default:
            this.title = title
            this.content = content
            break
          case 1:
            this.title = i18n.t('__requiredTitle')
            this.content = i18n.t('__requiredContent')
            break
          case 2:
            this.title = i18n.t('__newTitle')
            this.content = i18n.t('__newContent')
            break
          case 3:
            this.title = i18n.t('__revisedTitle')
            this.content = i18n.t('__revisedContent')
            break
          case 4:
            this.title = i18n.t('__deleteTitle')
            this.content = i18n.t('__deleteContent')
            break
          case 5:
            this.title = i18n.t('__importTitle')
            this.content = i18n.t('__importContent')
            break

          case 7:
            this.title = i18n.t('__imageTitle')
            this.content = i18n.t('__imageContent')
            break
          case 8:
            this.title = i18n.t('__imageSizeTitle')
            this.content = i18n.t('__imageContent2')
            break
          case 9:
            this.title = i18n.t('__imageSizeTitle')
            this.content = i18n.t('__imageSize500Content')
            break
          case 10:
            this.title = i18n.t('__ckeditorTitle')
            this.content = i18n.t('__ckeditorContent')
            break
          case 11:
            this.title = i18n.t('__querySuccessTitle')
            this.content = i18n.t('__querySuccessContent')
            break
          case 12:
            this.title = i18n.t('__ckeditorTitle')
            this.content = i18n.t('__ckeditorContent1')
            break
          case 13:
            this.title = i18n.t('__maintenanceAnnouncementTitle')
            this.content = i18n.t('__maintenanceAnnouncementContent')
            break
          case 14:
            this.title = i18n.t('__maintenanceAnnouncementWrongTitle')
            this.content = i18n.t('__maintenanceAnnouncementWrongContent')
            break
          case 15:
            this.title = i18n.t('__batchBodificationTitle')
            this.content = i18n.t('__batchBodificationContent')
            break
          case 16:
            this.title = i18n.t('__systemHint')
            this.content = i18n.t('__pleaseSelectItem')
            break
        }
      },
      close(){
        this.active = false
      },
      save(){
        if(this.onSaveEn){
          this.onSave()
        }
        this.close()
      }
    }
  }
</script>